export default __webpack_public_path__ + "static/media/covid.c4839699.jfif";